import {
  Button,
  Stack,
  Box,
  Slide,
  Slider,
  styled,
  ClickAwayListener,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { tease } from "../components/CheckButton";
import {
  AccountType,
  ButtonStyle,
  Color,
  ContactType,
  ErrorCode,
  FontStyle,
  JobDisplays,
  navPaddingTop,
  QuestionData,
  Slug,
  SurveyButtonStyle,
  SurveyColumn,
} from "../constants";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { StyledTextField } from "../components/AutocompleteUtils";
import { useDispatch, useSelector } from "react-redux";
import { stringEquals } from "../utils/utils";
import SettingsSort from "../components/SettingsSort";
import EmailSlider from "../components/EmailSlider";
import * as apiService from "../service/ApiService";
import { useNavigate } from "react-router-dom";
import { logout } from "../service/AuthService";
import FettiRadio from "../components/FettiRadio";
import { jobIdFromUrl } from "../utils/utils";
import BasicApply from "../components/ApplyPanels/BasicApply";
import FettiProgressBar from "../components/FettiProgressBar";
import { updateApplyData } from "../utils/actionUtils";
import ResumeApply from "../components/ApplyPanels/ResumeApply";
import QuestionsApply from "../components/ApplyPanels/QuestionsApply";
import ReviewApply from "../components/ApplyPanels/ReviewApply";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
  },
  container: {
    // marginTop: '67px',
    paddingTop: "3rem",
    paddingBottom: "110px",
    px: 4,
    backgroundColor: "#fff",
    // backgroundColor: "red",
    height: "100%",
    // alignItems: "stretch",
    minHeight: "calc(100vh - 67px)",
    width: "100%",
    textAlign: "center",
  },
};
const AlreadyAppliedPage = () => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{
        ...styles.outer,
      }}>
      <Stack
        sx={styles.container}
        direction="column"
        alignItems="center"
        spacing={3}>
        {/* <Stack sx={styles.panel} spacing={2}> */}
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
            ...FontStyle.headingBody,
            fontSize: { xs: "32px", md: "40px" },
          }}>
          You've already applied to this job!
        </Box>
        <Box
          sx={{
            width: "100%",
            ...FontStyle.body,
            fontSize: "16px",
            color: Color.secondaryTextGray,
          }}>
          Since you've already applied to this job, you can't apply again.
        </Box>
        <a href={Slug.jobResults}>
          <Button
            sx={{
              ...SurveyButtonStyle.defaultStyling,
              ...SurveyButtonStyle.primaryColorScale,
              width: "400px",
            }}
            disableRipple
            fullWidth>
            Back to Job Matches
          </Button>
        </a>
        {/* </Stack> */}
      </Stack>
    </Stack>
  );
};

export default AlreadyAppliedPage;
